import apiClient from './client';

export interface Invite {
  id: number;
  code: string;
  invite_type: 'employee' | 'client';
  email: string;
  target_employee_id?: number;
  target_client_id?: number;
  target_employee_name?: string;
  target_client_name?: string;
  is_reset?: number | boolean;
  expires_at: string;
  used_at?: string;
  created_by_name?: string;
  created_at: string;
  inviteUrl?: string;
}

export const listInvites = async (): Promise<Invite[]> => {
  const { data } = await apiClient.get('/invites');
  return data.data;
};

export const createInvite = async (params: {
  invite_type: 'employee' | 'client';
  email: string;
  target_employee_id?: number;
  target_client_id?: number;
  expires_days?: number;
  /** Allow this invite to set a NEW password on an existing account (lost access). */
  is_reset?: boolean;
}): Promise<Invite> => {
  const { data } = await apiClient.post('/invites', params);
  return data.data;
};

export const revokeInvite = async (id: number): Promise<void> => {
  await apiClient.delete(`/invites/${id}`);
};

// Re-send the invite email; renews expiry (+7d) if the link had expired.
export const resendInvite = async (id: number): Promise<Invite> => {
  const { data } = await apiClient.post(`/invites/${id}/resend`);
  return data.data;
};
